<template>
  <div class="create-item">
    <!-- 上传标题 -->
    <div class="my-card">
      <div class="title">
        <img v-if="props.spu"
             :src="toUrl(spu?.image)">
        <p class="design-title">{{ spu?.name }}</p>
      </div>
      <a-button class="upload-button"
                @click="addCustomText">
        <plus-outlined class="upload-button-icon" />
        <span class="upload-button-title">{{ $t('CustomSpus.CreateItemPages.addText') }}</span>
      </a-button>
      <a-upload :action="toUrl('/v1/api/directAttachment/material')"
                :show-upload-list="false"
                :with-credentials="true"
                accept="image/png, image/jpeg"
                :file-list="fileList"
                :before-upload="verifyUploadImgName"
                @change="handleChange">
        <a-button class="upload-button"
                  @click="toLogin($event)">
          <plus-outlined class="upload-button-icon" />
          <span class="upload-button-title">{{ $t('CustomSpus.UpLoadImage.uploadImage') }}</span>
        </a-button>
      </a-upload>
      <a-popconfirm :title="$t('CustomSpus.CreateItemPages.toggleWarning')"
                    @confirm="changeExternalProcurementType">
        <a-button v-show="isCustomized"
                  :class="['upload-button', externalProcurement ? 'upload-button-selected' : '']">
          <span class="upload-button-title">{{ $t('CustomSpus.CreateItemPages.externalProcurementNoImg') }}</span>
        </a-button>
      </a-popconfirm>
      <a-button v-show="!isCustomized"
                :class="['upload-button', externalProcurement ? 'upload-button-selected' : '']"
                @click="changeExternalProcurementType">
        <span class="upload-button-title">{{ $t('CustomSpus.CreateItemPages.externalProcurementNoImg') }}</span>
      </a-button>
      <a-upload v-show="externalProcurement"
                :action="toUrl('/v1/api/directAttachment/material')"
                :show-upload-list="false"
                :with-credentials="true"
                accept="image/png, image/jpeg"
                :file-list="fileList"
                :before-upload="verifyUploadImgName"
                @change="uploadExternalProcurementImg">
        <a-button class="upload-button-secondary"
                  @click="toLogin($event)">
          <plus-outlined class="upload-button-icon" />
          <span class="upload-button-title">{{ $t('CustomSpus.CreateItemPages.externalProcurement') }}</span>
        </a-button>
      </a-upload>
      <!-- <a-button class="upload-button"
                @click="emit('clearArea')">
        <span class="upload-button-title">{{ $t('CustomSpus.CreateItemPages.clearArea') }}</span>
      </a-button> -->
    </div>
  </div>
</template>
<script setup lang="ts">
import { reactive, ref, watch } from 'vue'
import { addMateriaImage, getUserMaterialList } from '../../api'
import { message, type UploadProps } from 'ant-design-vue'
import type { UploadChangeParam } from 'ant-design-vue/es/upload/interface'
import type { CustomizedAreasScale, CustomPrice, CustomPriceDetail, CustomSpu, Spu } from '../../types'
import { toUrl, verifyUploadImgName } from "@/utils"
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const props = defineProps<{
  isLogin: boolean
  spu: Spu | undefined
  isAreaCustomized: CustomPrice[]
  isExternalProcurement: boolean
  isCustomized: boolean
  currentCustomAreaScale: CustomizedAreasScale[]
}>()

const externalProcurement = ref<boolean>(false)
const materialItems = ref<any>([])
const fileList = ref<UploadProps['fileList']>([])
const emit = defineEmits([
  'addCustomText',
  'changeCustomSpuName',
  'changes',
  'toLogin',
  'clearArea',
  'customizedLoading',
  'changeExternalProcurement',
  'uploadExternalProcurementImg',
  'uploadExternalProcurementLoading',
])

const customPriceDetail = ref<CustomPriceDetail>({
  spu_price: 0,
  spu_discount: {},
  customized_areas: [],
  custom_price: []
})

const toLogin = (event: any) => {
  if (!props.isLogin) {
    event.stopPropagation()
    emit('toLogin')
  }
}

// 商品名称售价
const customSpu = reactive<Partial<CustomSpu>>({
  name: '',
  // price: '',
})

watch(() => props.isAreaCustomized, () => {
  customPriceDetail.value.custom_price = props.isAreaCustomized
}, {
  deep: true,
  immediate: true
})

watch(() => props.isExternalProcurement, (newV) => {
  if (!newV)
    externalProcurement.value = false
  console.log(newV)

})

watch(() => props.spu?.price, () => {
  customPriceDetail.value.spu_price = props.spu?.price!
}, {
  immediate: true
})

watch(() => props.currentCustomAreaScale, () => {
  customPriceDetail.value.customized_areas = props.currentCustomAreaScale
}, {
  deep: true,
  immediate: true
})

watch(() => customSpu.name, () => {
  emit('changeCustomSpuName', customSpu.name)
})

const addCustomText = () => {
  emit('addCustomText')
}

const changeExternalProcurementType = () => {
  externalProcurement.value = !externalProcurement.value
  emit('changeExternalProcurement', externalProcurement.value)
}

const uploadExternalProcurementImg = async (info: UploadChangeParam) => {
  emit('uploadExternalProcurementLoading', true)
  fileList.value = []
  fileList.value.push(info.file)
  if (info.file.status === 'done') {
    const data = {
      image: '',
      name: '',
      specifications: ''
    }
    data.image = info.file.response.uploaded
    data.name = info.file.name
    const img = new Image()
    img.src = toUrl(info.file.response.uploaded) as string
    img.onload = async () => {
      const size = info.file.size ? (info.file.size / 1024).toFixed(2) : ''
      data.specifications = `t('CustomSpus.UpLoadImage.width')：${img.width}x${img.height} t('CustomSpus.UpLoadImage.type')：${info.file.type} t('CustomSpus.UpLoadImage.size')：${size}KB`
    }
    emit('uploadExternalProcurementImg', toUrl(data.image))
    emit('uploadExternalProcurementLoading', false)
  }
  if (info.file.status === 'error') {
    emit('uploadExternalProcurementLoading', false)
    message.error(t('CustomSpus.UpLoadImage.uploadFailed'))
    fileList.value = []
  }
}

const handleChange = async (info: UploadChangeParam) => {
  emit('customizedLoading', true)
  fileList.value = []
  fileList.value.push(info.file)
  if (info.file.status === 'done') {
    const data = {
      image: '',
      name: '',
      specifications: ''
    }
    data.image = info.file.response.uploaded
    data.name = info.file.name
    const img = new Image()
    img.src = toUrl(info.file.response.uploaded) as string
    img.onload = async () => {
      const size = info.file.size ? (info.file.size / 1024).toFixed(2) : ''
      data.specifications = `t('CustomSpus.UpLoadImage.width')：${img.width}x${img.height} t('CustomSpus.UpLoadImage.type')：${info.file.type} t('CustomSpus.UpLoadImage.size')：${size}KB`
      await addMateriaImage(data)
      await getUserMaterialList({}).then((result: any) => {
        materialItems.value = result.rows
      })
    }
    emit('changes', toUrl(data.image))
  }
  if (info.file.status === 'error') {
    message.error(t('CustomSpus.UpLoadImage.uploadFailed'))
    fileList.value = []
  }
}
</script>
<style scoped lang="less">
.create-item {
  width: 300px;
  flex: 1;
  background: white;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;

  .title {
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
  }

  .placeholder {
    flex: 1;
  }

  .color-grey {
    color: grey;
  }

  .horizontal-bar {
    width: 255px;
    margin-top: 15px;
    margin-left: 25px;
    border: 1px solid #F6F6F6;
  }

  .complete-button {
    width: 260px;
    height: 40px;
    color: white;
    background: #111111;
  }

  .my-card {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 60px;
      border: 1px solid #F1F1F1;
      height: 60px;
    }

    .design-title {
      margin-left: 23px;
      font-size: 16px;
      color: #111111;
    }

    .fun-title {
      display: inline-block;
      font-size: 16px;
      font-weight: 400;
      color: #111111;
      line-height: 20px;
      margin-bottom: 10px;
    }

    .color-text {
      display: flex;

      span {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
      }
    }

    p {
      color: #111111ad;
    }

    .color-list {
      .color-item-border {
        margin-right: 4.5px;
        min-height: 36px !important;
        min-width: 36px !important;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border: 1px solid rgb(215, 215, 215);

        .color-item {
          background-size: 100%;
          min-height: 36px !important;
          min-width: 36px !important;
        }

        .selected-color {
          border: 1px solid black;
        }
      }
    }
  }

  :deep(.ant-input-affix-wrapper) {
    width: 260px;
    height: 40px;
    border: 1px solid #F6F6F6 !important;
  }

  .upload-button-secondary {
    margin-top: 10px;
    border: none;
    width: 220px;
    height: 40px;
    background: #F6F6F6;
    display: flex;
    align-items: center;
    justify-content: center;

    .upload-button-icon {
      font-size: 16px;
    }

    .upload-button-title {
      font-size: 14px;
      font-weight: 400;
      color: #111111;
    }
  }

  .upload-button {
    margin-top: 10px;
    border: none;
    width: 240px;
    height: 46px;
    background: #F6F6F6;
    display: flex;
    align-items: center;
    justify-content: center;

    .upload-button-icon {
      font-size: 16px;
    }

    .upload-button-title {
      font-size: 14px;
      font-weight: 400;
      color: #111111;
    }
  }

  .upload-button-selected {
    border: 1px solid;
  }

  .my-card:last-child {
    padding-left: 20px;
    overflow: auto;
  }
}
</style>
